import React from 'react'
import { Fragment } from 'react'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import theme from 'theme'
import useStyles from './styles'

import logoNotFound from 'images/not-found-ticket.svg'

const NoDataMessages = ({ isLoading = false, skeletonCount = 4, children }) => {
  const classes = useStyles()

  return (
    <Fragment>
      {isLoading || isEmpty(children) ? (
        <Box
          display="flex"
          flexDirection="column"
          textAlign="center"
          gridGap={theme.spacing(3)}
          justifyContent="center"
          height="100%"
        >
          {isLoading ? (
            <>
              {Array.from({ length: skeletonCount }).map((_, index) => (
                <Box key={index}>
                  <Skeleton
                    width="100%"
                    height={72}
                    animation="wave"
                    variant="rect"
                  />
                  <Skeleton width="100%" height={82} variant="rect" />
                </Box>
              ))}
            </>
          ) : (
            <>
              <img
                height={150}
                src={logoNotFound}
                alt="Nenhuma interação neste ticket"
              />
              <Typography
                variant="h2"
                className={classes.noInteractionTypography}
              >
                Nenhuma interação encontrada
              </Typography>
            </>
          )}
        </Box>
      ) : (
        children
      )}
    </Fragment>
  )
}

NoDataMessages.propTypes = {
  isLoading: PropTypes.bool,
  skeletonCount: PropTypes.number,
  children: PropTypes.node,
}

export default NoDataMessages
